

















































































































import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import { OrderDto } from "@/types/impl/OrderDto";
import IImageComponent from "@/components/image.vue";
import { IUserInfoDto } from "@/types/interface/IUserInfoDto";
import { IOrderItemDto } from "../../../types/interface/IOrderItem";
import BigNumber from "bignumber.js";
import {
  OrderItemType,
  OrderStatus,
  OrderItemSubType,
  DeliveryType,
  OrderItemStatus,
  OrderPickupSubtype
} from "../../../types/enum/OrderEnum";
import PaymentTypeComponent from "@/components/paymen-type.vue";
import OrderStepStateComponent from "./order-step-status.vue";
import HeaderComponent from "./order-row-header.vue";
import OrderItemParams from "@/components/order-item-params.vue";
import USD from "../../../components/USD.vue";
import store from "../../../store/index";
import { State, Getter, Action, Mutation } from "vuex-class";
import {
  IOrderDto,
  IOrderPayload,
  IOrderPaging
} from "../../../types/interface/IOrderDto";
import { pullOrderDefaultUrl } from "@/store/actions.ts";
import { IOrderParkingLotDto } from "../../../types/interface/IOrderParkingLotDto";
import { toLocalTime, Operatore, uncodeUtf16 } from "../../../api/net/util";

@Component({
  name: "order-row",
  components: {
    IImageComponent,
    PaymentTypeComponent,
    OrderStepStateComponent,
    HeaderComponent,
    OrderItemParams,
    USD
  }
})
export default class OrderRow extends Vue {
  @Prop({ default: { ...OrderDto } }) order!: IOrderDto;
  @Prop({ default: -1 }) index!: number;
  @Prop({ default: {} }) paging!: IOrderPaging;
  @Prop({ default: [] }) orderStatusForRequestOrderList!: number[];
  @Mutation("handleOrderList")
  private mutationOrderList: (orderList: IOrderDto) => Promise<void>;
  @Action("handleOrderList")
  private actionHandleOrderList!: (payload: IOrderPayload) => Promise<void>;
  orderGroup = store.state.orderList;
  orderItemIds: Array<string> = [];

  orderItemPriceCalculation(
    subTotalExcludeTax: number,
    taxAmount: number
  ): string {
    return new BigNumber(Math.abs(subTotalExcludeTax)).toFixed(2);
  }

  public get deliveryType(): string {
    return this.order.deliveryType === DeliveryType.Delivery
      ? "Delivery"
      : "Pickup";
  }

  public get orderItems(): IOrderItemDto[] {
    const renderType = [OrderItemType.Normal, OrderItemType.Reversal];

    let orderItems = this.order.orderItems.length ? this.order.orderItems : [];
    if (!orderItems.length) {
      return [];
    }

    let normalItems = orderItems.filter(
      (x: IOrderItemDto) => x.itemType === OrderItemType.Normal
    );

    let reversalItems = orderItems.filter(
      (x: IOrderItemDto) => x.itemType === OrderItemType.Reversal
    );

    if (!reversalItems.length) {
      return normalItems;
    }

    let reversalItemsIdList: string[] = reversalItems.map(
      (x: IOrderItemDto) => x.id as string
    );

    let resultItems = normalItems.reduce(
      (arr: IOrderItemDto[], currentItem: IOrderItemDto) => {
        if (reversalItemsIdList.includes(currentItem.foodId as string)) {
          return [
            ...arr,
            ...reversalItems.filter(
              (x: IOrderItemDto) => x.id === currentItem.id
            )
          ];
        }
        return [...arr, currentItem];
      },
      []
    );
    return resultItems;
  }

  public get orderTotal(): string {
    return (
      new BigNumber(this.order.orderTotalReceivedByMerchant).toFixed(2) || "0"
    );
  }

  public get address(): string {
    return `${this.order.address.address1}`;
  }

  public get unit(): string {
    if (this.order.address.unit) {
      return `${this.order.address.unit}`;
    }
    return "";
  }

  public get gateCode(): string {
    if (this.order.address.gateCode) {
      return `${this.order.address.gateCode}`;
    }
    return "";
  }

  public get apartmentNumber(): string {
    if (this.order.address.apartmentNumber) {
      return `${this.order.address.apartmentNumber}`;
    }
    return "";
  }

  public get deliveryNotes(): string {
    if (this.order.address.deliveryNotes) {
      return `${this.order.address.deliveryNotes}`;
    }
    return "";
  }

  public get contact(): string {
    if (this.order.address.contact) {
      return `${this.order.address.contact}`;
    }
    return "";
  }

  public get phone(): string {
    return `${this.order.address.phone}`;
  }

  public get zipCode(): string {
    return `${this.order.address.postalCode}`;
  }

  public toOrderDetailPage(): void {
    const selectedText: string = (window.getSelection() as any)
      .toString()
      .replace(/\s*/g, "");
    if (!selectedText) {
      this.$router.push({
        name: "Order Detail",
        query: {
          orderId: this.order.id,
          from: pullOrderDefaultUrl.orderUrl
        }
      });
    }
  }

  public get totalItem(): number {
    return this.orderItems
      .map(item => item.quantity)
      .reduce((totalItemAmount: number, currentItemAmount: number) => {
        return totalItemAmount + currentItemAmount;
      }, 0);
  }

  itemCanceled(itemStatus: number): boolean {
    return itemStatus === OrderItemStatus.Canceled || !!this.order.rejectedAt;
  }

  public get showPickingLot(): boolean {
    return this.order.pickupSubtype === OrderPickupSubtype.ParkingLotPickup;
  }

  public get parkingLot(): IOrderParkingLotDto[] {
    let parkingLotInfo: IOrderParkingLotDto[] = JSON.parse(
      JSON.stringify(this.order.orderParkingLotPickupFieldValues)
    );
    return parkingLotInfo.sort(
      (a: IOrderParkingLotDto, b: IOrderParkingLotDto) => {
        return a.name.substring(0, 1).toUpperCase() >
          b.name.substring(0, 1).toUpperCase()
          ? -1
          : a.name.substring(0, 1).toUpperCase() <
            b.name.substring(0, 1).toUpperCase()
          ? 1
          : 0;
      }
    );
  }

  public get customerArrivedDate(): string {
    if (this.order.customerArrivedDate) {
      return toLocalTime(
        `${this.order.customerArrivedDate}`,
        Operatore.Horizontal
      );
    } else {
      return "";
    }
  }

  public get specialInstructions(): string {
    return this.order.remark ? uncodeUtf16(`${this.order.remark}`) : "";
  }

  public get isShowSpecialInstructions(): boolean {
    return (
      !!this.specialInstructions && this.order.merch.acceptSpecialInstruction
    );
  }

  updated() {
    store.commit("handleShowLoading", false);
  }

  updateOrderList(orderId: string, merchId: string) {
    this.$emit("updateOrderList", orderId, merchId);
  }
}
